// import store from '../../store'

export default function autenticacao (to, from, next) {
  next()
}
